/**
 * 权限查看Modal配置
 * 用于查看角色权限的树形配置
 * 参考管理员页面的权限对话框设计
 */

/**
 * 权限查看弹窗尺寸配置
 * 参考管理员页面的配置
 */
export const permissionViewModalSize = {
  width: 600,
  height: "60vh",
  maxWidth: "95vw",
  minWidth: 600,
};

/**
 * 权限查看弹窗搜索配置
 * 参考管理员页面的配置
 */
export const permissionViewSearchConfig = {
  enabled: true,
  placeholder: "搜索权限名称、编码或服务...",
};

/**
 * 权限查看弹窗选择配置
 * 参考管理员页面的配置：禁用选择功能（仅查看，不可修改）
 */
export const permissionViewSelectionConfig = {
  enabled: false,
};

/**
 * 权限查看弹窗树形配置
 * 参考管理员页面的配置
 */
export const permissionViewTreeConfig = {
  defaultExpandAll: true,
  showLine: true,
  showIcon: true,
};

/**
 * 权限查看弹窗 Modal 属性配置
 * 参考管理员页面的配置
 */
export const permissionViewModalProps = {
  maskClosable: false,
  destroyOnClose: true,
};

/**
 * 权限查看弹窗操作按钮配置
 * 参考管理员页面的配置：只显示关闭按钮，不显示取消按钮
 */
export const permissionViewActionConfig = {
  showCancel: false, // 不显示取消按钮
  showClose: true, // 显示关闭按钮
  closeText: "关闭", // 关闭按钮文本
};
